import { Product } from '../stores/ProductModel'

export const getPriceOptionsFromProduct = (product: Product) => {
	return (
		product.product_variants?.map((variant) => {
			const { label, value } = variant.options
			return { label, value }
		}) || []
	)
}
